<div class="row animated fadeIn">
    <div class="col-md-12">
        <div class="row justify-content-between align-items-center mb-2 zIndexUp">
            <h4 class="col-xl-auto col-lg-auto col-md-6 col-sm-6 mb-lg-0 mb-sm-2 mb-md-2 mb-2">Inquiry</h4>
            <ul
                class="list-unstyled action-tool-bar col-xl-auto col-lg-auto col-md-10 col-sm-12 mb-0 d-flex align-items-center flex-wrap">
                <li> <a href="javascript:void(0);" class="btn btn-sm btn-light-info bg-info border-info"
                        (click)="openClosefun()"><span class="mdi mdi-filter"></span>
                        Filter</a></li>

                <li *ngIf="permission.Inquiry_Export==1 || roleId==1"> <a href="javascript:void(0);"
                        class="btn btn-sm btn-light-info bg-primary border-primary "
                        (click)="ExportOpenModal(exportConfirm)"><span class="mdi mdi-export"></span>
                        Export</a></li>
                <li *ngIf="permission.Inquiry_Add==1 || roleId==1">
                    <a href="javascript:void(0);" class="btn btn-sm btn-light-info bg-danger border-danger"
                        (click)="importDocument.show()">
                        <span class="mdi mdi-import"></span> Import</a>
                </li>

                <li *ngIf="permission.Inquiry_Add==1 || roleId==1"> <a href="javascript:void(0);"
                        routerLink="/inquiry/addinquiry" class="btn btn-sm btn-light-info"><span
                            class="mdi mdi-plus"></span>
                        Add Inquiry</a></li>
            </ul>
        </div>

        <div class="card mt-3" *ngIf="isCollapsed">
            <div class="card-body cb-pad-adjust">
                <form [formGroup]="registerForm">
                    <div class="form-row">
                        <div class="col-xl-2 col-lg-6 mb-2">
                            <small class="same-height-label-1">Project Name (Project ID)</small>
                            <angular2-multiselect formControlName="ProjectId" [settings]="dropdownSetting1"
                                [data]="showProject" [(ngModel)]="selectedproject" (onSelect)="onProjectSelect($event)"
                                (onDeSelect)="onProjectSelect($event)" (onSelectAll)="onProjectSelect($event)"
                                (onDeSelectAll)="onProjectSelect($event)" fixSearchBug>
                            </angular2-multiselect>
                        </div>

                        <div class="col-xl-2 col-lg-6 mb-2">
                            <small class="same-height-label-1">Inquiry Name (Inquiry ID)</small>
                            <angular2-multiselect formControlName="InquiryName" [settings]="dropdownSetting2"
                                [data]="showInquiry" [(ngModel)]="selectedinquiry" (onSelect)="onInquirySelect($event)"
                                (onDeSelect)="onInquirySelect($event)" (onSelectAll)="onInquirySelect($event)"
                                (onDeSelectAll)="onInquirySelect($event)" fixSearchBug>
                            </angular2-multiselect>
                        </div>
                        <div class="col-xl-2 col-lg-6 mb-2">
                            <small class="same-height-label-1">Customer Name</small>
                            <angular2-multiselect formControlName="CustomerName" [settings]="dropdownSetting3"
                                [data]="showCustomer" [(ngModel)]="selectedcustomer"
                                (onSelect)="onCustomerSelect($event)" (onDeSelect)="onCustomerSelect($event)"
                                (onSelectAll)="onCustomerSelect($event)" (onDeSelectAll)="onCustomerSelect($event)"
                                fixSearchBug>
                            </angular2-multiselect>
                        </div>
                        <div class="col-xl-2 col-lg-6 mb-2">
                            <small class="same-height-label-1">Business Vertical</small>
                            <angular2-multiselect formControlName="BusinessVertical" [settings]="dropdownSetting12"
                                [data]="businessVertical" [(ngModel)]="selectedBusiness"
                                (onSelect)="onBusinessSelect($event)" (onDeSelect)="onBusinessSelect($event)"
                                (onSelectAll)="onBusinessSelect($event)" (onDeSelectAll)="onBusinessSelect($event)"
                                fixSearchBug>
                            </angular2-multiselect>
                        </div>
                        <div class="col-xl-2 col-lg-6 mb-2">
                            <small class="same-height-label-1">Stages</small>
                            <angular2-multiselect formControlName="StageId" [settings]="dropdownSetting8"
                                [data]="showStage" [(ngModel)]="selectedstage" (onSelect)="onStageSelect($event)"
                                (onDeSelect)="onStageSelect($event)" (onSelectAll)="onStageSelect($event)"
                                (onDeSelectAll)="onStageSelect($event)" fixSearchBug>
                            </angular2-multiselect>
                        </div>
                        <div class="col-xl-2 col-lg-6 mb-2">
                            <small class="same-height-label-1">Inquiry Prob</small>
                            <angular2-multiselect formControlName="InquiryProbability" [settings]="dropdownSetting9"
                                [data]="showProbability" [(ngModel)]="selectedprobability"
                                (onSelect)="onProbabilitySelect($event)" (onDeSelect)="onProbabilitySelect($event)"
                                (onSelectAll)="onProbabilitySelect($event)"
                                (onDeSelectAll)="onProbabilitySelect($event)" fixSearchBug>
                            </angular2-multiselect>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-xl-2 col-lg-6 mb-2">
                            <small class="same-height-label-1">Quotation Engineer</small>
                            <angular2-multiselect formControlName="QuotationEngineerId" [settings]="dropdownSetting10"
                                [data]="showQuotationEr" [(ngModel)]="selectedquotationEr"
                                (onSelect)="onQuotationErSelect($event)" (onDeSelect)="onQuotationErSelect($event)"
                                (onSelectAll)="onQuotationErSelect($event)"
                                (onDeSelectAll)="onQuotationErSelect($event)" fixSearchBug>
                            </angular2-multiselect>
                        </div>
                        <div class="col-xl-2 col-lg-6 mb-2">
                            <small class="same-height-label-1">Sales Engineer</small>
                            <angular2-multiselect formControlName="SalesEngineerId" [settings]="dropdownSetting11"
                                [data]="showSalesEr" [(ngModel)]="selectedsalesEr" (onSelect)="onSalesErSelect($event)"
                                (onDeSelect)="onSalesErSelect($event)" (onSelectAll)="onSalesErSelect($event)"
                                (onDeSelectAll)="onSalesErSelect($event)" fixSearchBug>
                            </angular2-multiselect>
                        </div>
                        <div class="col-xl-2 date-filter-field-2 date-filter-second-last-field col-lg-6 mb-2">
                            <small class="same-height-label-1"><input type="checkbox" class="mr-1 cursor-pointer"
                                    formControlName="IsQuotedDate" />
                                Quoted Date</small>
                            <div class="input-group">
                                <div class="w-100 position-relative">
                                    <input class="form-control" type="text" [showDropdowns]="true" ngxDaterangepickerMd
                                        [(ngModel)]="date_range" [settings]="dropdownSettings"
                                        [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [ranges]="ranges"
                                        (keydown)="disableDate()" [showClearButton]="true" placeholder="DD-MM-YYYY"
                                        [ngModelOptions]="{standalone: true}" />
                                    <sapn class="position-absolute"
                                        style="top: 48%; right: -5px; transform: translate(-50%, -50%);">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                            fill="currentColor" class="bi bi-x" viewBox="0 0 16 16"
                                            (click)="clearStartDate()">
                                            <path
                                                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                        </svg>
                                    </sapn>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-2 date-filter-field-2 date-filter-last-field col-lg-6 mb-3 mb-xl-2">
                            <small class="same-height-label-1"><input type="checkbox" class="mr-1 cursor-pointer"
                                    formControlName="IsExpectedDate" />
                                Expected Date</small>
                            <div class="input-group">
                                <div class="w-100 position-relative">
                                    <input class="form-control" type="text" [showDropdowns]="true" ngxDaterangepickerMd
                                        (keydown)="disableDate()" [(ngModel)]="date_range2"
                                        [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [ranges]="ranges"
                                        [ngModelOptions]="{standalone: true}" [showClearButton]="true"
                                        placeholder="DD-MM-YYYY" />
                                    <sapn class="position-absolute"
                                        style="top: 48%; right: -5px; transform: translate(-50%, -50%);">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                            fill="currentColor" class="bi bi-x" viewBox="0 0 16 16"
                                            (click)="clearEndDate()">
                                            <path
                                                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                        </svg>
                                    </sapn>
                                </div>
                            </div>
                        </div>
                        <div class="col-auto mb-2 mb-xl-0">
                            <small class="same-height-label-1 d-none d-xl-block"> &nbsp; </small>
                            <a href="javascript:void(0);" type="submit"
                                class="btn btn-outline-info d-flex align-items-center btn-new-light-info" title="Apply"
                                (click)="onSubmit()">
                                <i class="mdi mdi-checkbox-marked-outline mdi-18px"></i> Apply</a>
                        </div>
                        <div class="col-auto mb-2 mb-xl-0">
                            <small class="same-height-label-1 d-none d-xl-block"> &nbsp; </small>
                            <a href="javascript:void(0);"
                                class="btn btn-outline-info d-flex align-items-center btn-new-light-info" title="Reset"
                                (click)="resetData()">
                                <i class="mdi mdi-reload mdi-18px"></i></a>

                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <div class="table-responsive">
                    <mat-form-field class="example-full-width pb-0 w-100 form-control-design1" appearance="fill"
                        style="width: 250px !important; float: right;">
                        <input #inputField matInput class="text-limit  pos-search" [(ngModel)]="searchword"
                            placeholder="Search" (keyup.enter)="applyFilter()" />
                        <span class="mdi mdi-magnify mdi-2x cursor-pointer " title="Search"
                            style="position: absolute;right: 0;font-size: 20px;color: #999;top: 0;"
                            (click)="applyFilter();">
                        </span>
                        <span class="position-absolute" style="top: 50%; right: 7%; transform: translate(-50%, -50%);"
                            title="Clear">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                class="bi bi-x" viewBox="0 0 16 16" (click)="clearUserData(); applyFilter()"
                                (clearEvent)="searchword=''" *ngIf="searchword">
                                <path
                                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                            </svg>
                        </span>
                    </mat-form-field>
                    <table class="table table-mini-th" mat-table matSorts [dataSource]="dataSource" matSort
                        [matSortActive]="'name'" [matSortDisableClear]="true" [matSortDirection]="'asc'"
                        [multiTemplateDataRows]="true" (matSortChange)="onSortData($event)" aria-hidden="true">
                        <ng-container matColumnDef="ProjectName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                style="min-width: 140px;max-width: 200px;" class="p-1 font-12">Project Name
                                (Project Id)<img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort!='ProjectName'"><img src="assets/images/sort_up.png"
                                    *ngIf="upicon && !downicon && columnsort =='ProjectName'" alt=""><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='ProjectName'"></th>
                            <td mat-cell *matCellDef="let element" class="p-1 font-12">{{element['ProjectName']}}
                                <br />({{element['ProjectNumber']}})
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="InquiryName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                style="min-width:170px;max-width: 200px;" class="p-1 font-12">Inquiry Name
                                (Inquiry Id)<img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort!='InquiryName'"><img src="assets/images/sort_up.png"
                                    *ngIf="upicon && !downicon && columnsort =='InquiryName'" alt=""><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='InquiryName'"></th>
                            <td mat-cell *matCellDef="let element" class="p-1 font-12"><a href="javascript:void(0);"
                                    (click)="view(element.InquiryId)">{{element['InquiryName']}}<br />
                                    <small>({{element['InquiryNumber']}})</small></a>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="CustomerName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="p-1 font-12" style="min-width: 150px;
                            max-width: 200px;">Customer Name<img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort!='CustomerName'"><img src="assets/images/sort_up.png" alt=""
                                    *ngIf="upicon && !downicon && columnsort =='CustomerName'"><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='CustomerName'">
                            </th>
                            <td mat-cell *matCellDef="let element" class="p-1 font-12">{{element['CustomerName']}}</td>
                        </ng-container>

                        <ng-container matColumnDef="BussinessVerticals">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="p-1 font-12">Business
                                Verticals<img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort!='BussinessVerticals'"><img src="assets/images/sort_up.png"
                                    *ngIf="upicon && !downicon && columnsort =='BussinessVerticals'" alt=""><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='BussinessVerticals'">
                            </th>
                            <td mat-cell *matCellDef="let element" class="p-1 font-12">
                                {{element['BusinessVerticalName']}}</td>
                        </ng-container>

                        <ng-container matColumnDef="Stage">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="p-1 font-12">Stage<img
                                    src="assets/images/sort_both.png" alt="" *ngIf="columnsort!='Stage'"><img
                                    src="assets/images/sort_up.png" alt=""
                                    *ngIf="upicon && !downicon && columnsort =='Stage'"><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='Stage'">
                            </th>
                            <td mat-cell *matCellDef="let element" class="p-1 font-12">{{element['StageName']}}</td>
                        </ng-container>

                        <ng-container matColumnDef="InquiryProbability">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="p-1 font-12">Inquiry Prob<img
                                    src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort!='InquiryProbability'"><img src="assets/images/sort_up.png" alt=""
                                    *ngIf="upicon && !downicon && columnsort =='InquiryProbability'"><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='InquiryProbability'">
                            </th>
                            <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                {{element['InquiryProbabilityPercentage']}}</td>
                        </ng-container>

                        <ng-container matColumnDef="QuotationEngineer">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                style="min-width: 140px;max-width:200px;" class="p-1 font-12">Quotation
                                Engineer<img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort!='QuotationEngineer'"><img src="assets/images/sort_up.png"
                                    *ngIf="upicon && !downicon && columnsort =='QuotationEngineer'" alt=""><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='QuotationEngineer'">
                            </th>
                            <td mat-cell *matCellDef="let element" class="p-1 font-12">
                                {{element['QuotationEngineerName']}}</td>
                        </ng-container>

                        <ng-container matColumnDef="SalesEngineer">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                style="min-width: 140px;max-width:200px;" class="p-1 font-12">Sales Engineer<img
                                    src="assets/images/sort_both.png" alt="" *ngIf="columnsort!='SalesEngineer'"><img
                                    src="assets/images/sort_up.png" alt=""
                                    *ngIf="upicon && !downicon && columnsort =='SalesEngineer'"><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='SalesEngineer'">
                            </th>
                            <td mat-cell *matCellDef="let element" class="p-1 font-12">{{element['SalesEngineerName']}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="QuotedDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 80px;"
                                class="p-1 font-12">Quoted
                                Date<img src="assets/images/sort_both.png" alt="" *ngIf="columnsort!='QuotedDate'"><img
                                    src="assets/images/sort_up.png" alt=""
                                    *ngIf="upicon && !downicon && columnsort =='QuotedDate'"><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='QuotedDate'">
                            </th>
                            <td mat-cell *matCellDef="let element" class="p-1 font-12">{{element['QuotedDate']}}</td>
                        </ng-container>

                        <ng-container matColumnDef="QuotedValue">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="p-1 font-12">Total Quoted
                                Value<img src="assets/images/sort_both.png" *ngIf="columnsort!='QuotedValue'"
                                    alt=""><img src="assets/images/sort_up.png" alt=""
                                    *ngIf="upicon && !downicon && columnsort =='QuotedValue'"><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='QuotedValue'">
                            </th>
                            <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                {{element['TotalQuotedValue'] | number : '1.2-2'}}<sapn
                                    *ngIf="element.TotalQuotedValue != null">
                                    <br>({{element['currencyName']}})
                                </sapn>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="ReportedValue">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="p-1 font-12">Total Reported
                                Value<img src="assets/images/sort_both.png" *ngIf="columnsort!='ReportedValue'"
                                    alt=""><img src="assets/images/sort_up.png" alt=""
                                    *ngIf="upicon && !downicon && columnsort =='ReportedValue'"><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='ReportedValue'">
                            </th>
                            <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                {{element['TotalReportedValue'] | number : '1.2-2'}}<span
                                    *ngIf="element.ReportedValue != null"><br>(QAR)</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="ExpOrderDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 100px;"
                                class="p-1 font-12">Exp. Order
                                Date<img src="assets/images/sort_both.png" *ngIf="columnsort!='ExpOrderDate'"
                                    alt=""><img src="assets/images/sort_up.png" alt=""
                                    *ngIf="upicon && !downicon && columnsort =='ExpOrderDate'"><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='ExpOrderDate'">
                            </th>
                            <td mat-cell *matCellDef="let element" class="p-1 font-12">{{element['ExpOrderDate']}}</td>
                        </ng-container>

                        <ng-container matColumnDef="Action">
                            <th mat-header-cell *matHeaderCellDef class="p-1 font-12"><span
                                    class="mdi mdi-settings"></span>
                            </th>
                            <td mat-cell *matCellDef="let element" class="p-1 font-12">
                                <div ngbDropdown class="d-block list-dropdown-box"
                                    *ngIf="permission.Inquiry_Edit==1 || permission.Inquiry_Delete==1 || permission.Inquiry_ManageAction==1 || roleId==1">
                                    <a href="javascript:void(0);" class="text-center d-block" id="dropdownBasic1"
                                        ngbDropdownToggle> <i class="mdi mdi-dots-vertical mdi-24"></i></a>
                                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu-right">
                                        <div class="d-block">
                                            <div *ngIf="permission.Inquiry_Edit==1 || roleId==1">
                                                <a href="javascript:void(0);" class="" placement="bottom"
                                                    (click)="edit(element.InquiryId)"><button ngbDropdownItem><i
                                                            class="mdi mdi-pencil"></i>
                                                        Edit</button></a>
                                            </div>
                                            <div
                                                *ngIf="(permission.Inquiry_Delete==1 || roleId==1) && (element.TotalQuotedValue == 0 || element.TotalQuotedValue == null)">
                                                <a href="javascript:void(0);" class="" placement="bottom"
                                                    (click)="deleteOpenModal(deleteConfirm,element.InquiryName,element.InquiryId,element.InquiryNumber,3)"><button
                                                        ngbDropdownItem><i class="mdi mdi-delete"></i>
                                                        Delete</button></a>
                                            </div>
                                            <div *ngIf="permission.Inquiry_ManageAction==1 || roleId==1">
                                                <a href="javascript:void(0);" class="" placement="bottom"
                                                    (click)="show(element.InquiryId)"><button ngbDropdownItem><i
                                                            class="mdi mdi-library-books"></i>
                                                        Manage Product</button></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <tr class="odd" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <div *ngIf="TotalRecord == 0" class="text-center">
                        No Record found.
                    </div>
                    <div *ngIf="TotalRecord > 0">
                        <mat-paginator #paginator [pageSizeOptions]="[10, 20, 50, 100]" [length]="totalSize"
                            showFirstLastButtons aria-label="Select page of periodic elements" [pageIndex]="currentPage"
                            (page)="handlePage($event)" [pageSize]="pageSize">
                        </mat-paginator>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!--Import Inquiry -->
<div class="modal fade" bsModal #importDocument="bs-modal" [config]="{backdrop: 'static', keyboard: false}"
    tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content animated zoomIn">
            <div class="modal-header">
                <h4 id="dialog-static-name" class="modal-title pull-left">Import Inquiry</h4>
                <button type="button" class="close pull-right" aria-label="Close"
                    (click)="importDocument.hide();rtnView();">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="form-row animated fadeIn">
                    <div class="col-lg-12 col-md-12">
                        <div class="form-group mb-0">
                            <label>Upload Inquiry Document</label>
                            <input type="file" id="" class="form-control" (change)="onChange($event)" accept=".xlsx"
                                #inputFile>
                        </div>
                        <p class="text-info mb-0 mt-1"><a href={{sampleInquiryExl}}>Download
                                Sample File</a></p>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button href="javascript:void(0);" class="btn btn-sm btn btn-info" (click)="import();">Import</button>
                <input #showimport (click)="ImportResult.show()" type="hidden">
                <a href="javascript:void(0);" class="btn btn-sm btn btn-secondary ml-2"
                    (click)="importDocument.hide();rtnView();">Close</a>
            </div>
        </div>
    </div>
</div>

<!--Start Company Import Result modal-->
<div class="modal fade" bsModal #ImportResult="bs-modal" [config]="{backdrop: 'static', keyboard: false}" tabindex="-1"
    role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content animated zoomIn">
            <div class="modal-header">
                <h4 id="dialog-static-name" class="modal-title pull-left">Inquiry Import Result</h4>
            </div>
            <div class="modal-body">
                <form action="">
                    <div class="form-row animated fadeIn">
                        <div class="col-lg-12 col-md-12">
                            <div class="form-group mb-0">
                                <label>Total Records:
                                    <span class="font-weight-bold"> {{Totalrec}} </span>
                                </label>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12">
                            <div class="form-group mb-0">
                                <label>Successful Records:
                                    <span class="font-weight-bold">{{valid}}</span>
                                </label>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12">
                            <div class="form-group mb-0">
                                <label>Invalid Records:
                                    <span class="font-weight-bold d-inline-block" (click)="openClosefun1()"
                                        style="cursor:pointer">
                                        {{invalid}}</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form-row animated fadeIn" *ngIf="isCollapsed1">
                        <div class="col-lg-12 col-md-12">
                            <div class="table-responsive" style="max-height: 300px;">
                                <table class="table mb-0" aria-hidden="true">
                                    <tbody>
                                        <tr *ngFor="let item of dataarray; let i = index">
                                            <td>Row {{item.Row}}</td>
                                            <td>{{item.Error}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <div class="modal-footer">
                <a href="javascript:void(0);" (click)="ImportResult.hide(); importDocument.hide(); rtnView();"
                    class="btn btn-sm btn btn-info">OK</a>
            </div>
        </div>
    </div>
</div>

<!--Export-->
<ng-template #exportConfirm>
    <div class="modal-body text-center">
        <p>Do you want to export?</p>
        <button type="button" class="btn btn-info btn-sm" (click)="exportinquiry(); modalRef.hide();"
            [disabled]="exportName">Confirm</button>
        <button type="button" class="btn btn-light btn-sm ml-2" (click)="decline(); modalRef.hide();">Cancel</button>
    </div>
</ng-template>

<!--Delete modal-->
<ng-template #deleteConfirm>
    <div class="modal-header">
        <h4 class="modal-title text-dark"><strong>Inquiry Delete</strong></h4>
        <button type="button" class="close" (click)="decline(); modalRef.hide();" data-dismiss="modal"
            aria-label="Close"><span aria-hidden="true">&times;</span></button>
    </div>
    <div class="modal-body text-center">
        <p class="text-left mb-2"><strong>Inquiry Name: {{IqrName}} </strong></p>
        <p class="text-left mb-2"><strong>Inquiry Id: {{IqrNum}} </strong></p>
        <p class="text-left mb-2">Do you want to delete this Inquiry ?</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger btn-sm" (click)="deleteInquiry(); modalRef.hide();"
            [disabled]="delNameDel">Delete</button>
        <button type="button" class="btn btn-sm btn btn-secondary ml-2"
            (click)="decline(); modalRef.hide();">Cancel</button>
    </div>
</ng-template>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>